import style from './style.css';

const German = ({children}) => (
    <div id="german" class={style.german} lang="de">{children}</div>
);

export {German};
